<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center" style="min-width: 95%;">
    <div class="text-right cursor-pointer">
      <b-button variant="link" @click="back">
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Riferimenti normativi sul Property Management</h1>

    <loading-spinner v-if="loading" />
    <div v-else-if="$store.getters.isAuthenticated" class="row justify-content-between mx-2 mt-5 mb-2 align-middle">
      <h4>Elenco normative</h4>
    </div>

    <b-alert v-if="!loading && !items.length" show variant="info" class="my-4">
      Non ci sono normative da visualizzare.
    </b-alert>

    <b-table v-else-if="items.length" :per-page="perPage" :current-page="currentPage" data-pagination="true" striped
      bordered hover :fields="fields" :items="items" :responsive="true" :busy="false">
      <template v-slot:head(icon)>
        <font-awesome-icon icon="file-alt" size="lg" class="text-muted" />
      </template>

      <template v-slot:head(download)>
        <font-awesome-icon icon="download" size="lg" class="text-muted" />
      </template>
      <template v-slot:cell(download)="data">
        <a :href="urlNormativa(data.item.id)" target="_blank" @click.stop v-b-tooltip.hover title="Scarica il documento">
          <font-awesome-icon v-if="data.item.isDownloadable == 1" icon="file-alt" size="lg"
            class="text-success cursor-pointer" />
        </a>
      </template>

    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </div>
      <div class="text-right">
        <b-form-group description="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'id', label: 'Identificativo', sortable: true },
        { key: 'tipoRiferimento', label: 'Tipo riferimento', sortable: true },
        { key: 'segmentoPatrimonio', label: 'Segmento patrimonio', sortable: true },
        { key: 'anno', label: 'Anno', sortable: true },
        { key: 'dataValDal', label: 'Data valore dal', sortable: true, formatter: (value) => { return moment(value).format('DD/MM/YYYY') } },
        { key: 'dataValAl', label: 'Data valore al', sortable: true, formatter: (value) => { return moment(value).format('DD/MM/YYYY') } },
        { key: 'rifNormativo', label: 'Riferimento normativo', sortable: true },
        'download'
      ],
      loading: true,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15]
    }
  },

  async created() {
    await this.load()
  },

  methods: {

    back() {
      this.$router.push({ name: 'home' })
    },

    async load() {
      try {
        this.loading = true
        await this.$store.dispatch('normative/loadItems')
        this.items = this.$store.state.normative.items
        this.totalRows = this.items.length || 0
        // console.log('this.totalRows', )

      } catch (err) {
        this.$ui.showError(err)
      }
      this.loading = false
    },

    urlNormativa(id) {
      return `/api/normative/${id}/download`
    }

  }
}
</script>
